import React, { useContext } from "react";
import { ContextProvider } from "../../App";

import styles from "./authorizedHeader.module.css";
import { useHistory } from "react-router-dom";

function DropDownMenu({ email,mobile }) {
  const { authDispatch } = useContext(ContextProvider);
  const history = useHistory();

  const handleLogout = () => {
    localStorage.clear();
    authDispatch({ type: "LOGOUT_USER" });
    history.push("/");
  };

  return (
    <>
      <div className={styles.hover_menu_header_box}>
        <div
          className={styles.hover_li_header}
          style={{ borderBottom: "1px solid rgba(0,0,0, .2)" }}
        >
          <p>{email}</p>
        </div>
        <div
          className={styles.hover_li_header}
          style={{ borderBottom: "1px solid rgba(0,0,0, .2)" }}
        >
          <p>{mobile}</p>
        </div>
        <div
          className={styles.hover_li_header}
          style={{
            cursor: "pointer",
            borderBottom: "1px solid rgba(0,0,0, .2)",
          }}
          onClick={handleLogout}
        >
          <p>Logout</p>
        </div>
      </div>
    </>
  );
}

export default DropDownMenu;
